<template lang="pug">
.input-textarea-vertical(:style='setStyle')
  //- 入力内容表示
  .input-textarea-vertical__display(ref='display')
    .input-textarea-vertical__display__text-before(v-if='beforeText') {{ beforeText }}
    .input-textarea-vertical__display__value(@click='showPopup') {{ inputValue }}
    .input-textarea-vertical__display__text-after(v-if='afterText') {{ afterText }}
  //- 入力ポップアップ
  .input-textarea-vertical__popup(:data-show='isShowPopup')
    .input-textarea-vertical__popup__background(@click='hidePopup')
    .input-textarea-vertical__popup__body(:data-side='sidePosition')
      .input-textarea-vertical__popup__body__text-before(v-if='beforeText') {{ beforeText }}
      text-area-study.input-textarea-vertical__popup__body__input(ref='textareaStudy', v-model='inputValue')
      .input-textarea-vertical__popup__body__text-after(v-if='afterText') {{ afterText }}
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import TextAreaStudy from '@/components/molecules/student/TextAreaStudy.vue'

type side = 'left' | 'right'

/**
 * 記述式入力（縦書き）
 */
@Component({
  components: {
    TextAreaStudy,
  },
})
export default class InputTextareaVertical extends Vue {
  private isShowPopup = false
  private sidePosition: side = 'left'
  private topDistance = 0
  private sideDistance = 0

  // 入力値
  @Prop()
  value!: string

  // 前方テキスト
  @Prop()
  beforeText?: string

  // 後方テキスト
  @Prop()
  afterText?: string

  // テキストエリアref
  @Ref() textareaStudy!: TextAreaStudy

  // 入力内容表示部ref
  @Ref() display!: HTMLElement

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }

  private get setStyle(): { [key: string]: string } {
    return {
      '--popup-body-top': `${this.topDistance}px`,
      '--popup-body-side': `${this.sideDistance}px`,
    }
  }

  // 入力ポップアップを表示
  private showPopup() {
    this.setPositions()
    this.isShowPopup = true
    // テキストエリアにフォーカスする
    this.$nextTick(() => {
      this.textareaStudy.textarea.focus()
    })
  }

  /**
   * 入力内容表示部が画面全体の左右どちらにあるのか判定
   * 左の場合は入力ポップアップを表示部の左上端に、右の場合は右上端に合わせて表示
   */
  private setPositions() {
    const clientWidth = document.documentElement.clientWidth
    const triggerRect = this.display.getBoundingClientRect()
    this.topDistance = triggerRect.top
    if (triggerRect.left + triggerRect.width / 2 < clientWidth / 2) {
      this.sidePosition = 'left'
      this.sideDistance = triggerRect.left
    } else {
      this.sidePosition = 'right'
      this.sideDistance = clientWidth - triggerRect.right
    }
  }

  // 入力ポップアップを閉じる
  private hidePopup() {
    this.isShowPopup = false
  }
}
</script>

<style lang="stylus" scoped>
.input-textarea-vertical
  position relative

  &__display
    &__text-before
      margin-left 5px

    &__value
      overflow-x auto
      overflow-y hidden
      text-overflow ellipsis
      white-space pre-line
      word-break keep-all
      line-break anywhere
      min-width 72px
      max-width 115px
      height 100%
      padding 4px
      border 1px solid var(--color-default__border)
      border-radius 4px

    &__text-after
      margin-right 5px

  &__popup
    display none
    writing-mode horizontal-tb

    &__background
      position fixed
      left 0
      top 0
      z-index 100
      width 100%
      height 100%
      background-color var(--color-study-input-popup__background)
      opacity 0.6

    &__body
      position fixed
      top var(--popup-body-top)
      z-index 200
      width 60vw
      padding 20px
      background-color var(--color-default__box-background)
      border 1px solid var(--color-default__border)
      border-radius 4px
      &__text-before
        margin-bottom 5px
      &__text-after
        margin-top 5px
      &[data-side='left']
        left var(--popup-body-side)
      &[data-side='right']
        right var(--popup-body-side)

    &[data-show='true']
      display block
</style>
